import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import LoadingIndicator from 'Components/UI/LoadingIndicator';
import { QueryVal, addQuery } from 'Helpers/Query';
import fr from 'facet-rest';
import useCollection from 'Hooks/useCollection';
import MetaTable from 'Components/UI/Meta/MetaTable';
import { displayErrorMessage } from 'Helpers/FacetNotificationManager';
import useUserContext from 'Context/UserContext';
import CuratedContentArticleLayout from 'Layouts/CuratedContentArticle';

const styles = theme => ({
  root: {
    padding: theme.spacing(0, 2),
    width: '100%',
  },
});

function CuratedContentArticleTable({ className, classes }) {
  const { collection, setCollection } = useCollection();
  const { userResource } = useUserContext();
  const relationship = userResource?.relationship(fr.relationships.curatedContentArticles.name);

  // If the relationship doesn't exist on the user resource, this will need to be updated
  useEffect(() => {
    async function loadCuratedContentArticles() {
      try {
        const link = QueryVal('link') || relationship
          .link('related')
          .url();
        const response = await fr.http.Get(link);
        const curatedContentArticleCollection = fr.collection(response);
        setCollection(curatedContentArticleCollection);
        addQuery({ link });
      } catch (err) {
        displayErrorMessage(err, err.errors);
      }
    }
    if (relationship) {
      loadCuratedContentArticles();
    }
  }, [relationship]);

  if (relationship && collection == null) {
    return <LoadingIndicator />;
  }

  if (collection == null) {
    return null;
  }

  return (
    <MetaTable
      className={classNames(classes.root, className)}
      collection={collection}
      refreshNowLink="refreshCuratedContentArticles"
      hasSortableColumns
      tableMetaOverrideSetName="CuratedContentArticleTableOverride"
      features={
        {
          create: {
            type: 'dialog',
            button: 'Add Article',
            title: 'Add Article',
            metaOverrideSetName: 'CuratedContentArticleEditOverride',
            layout: CuratedContentArticleLayout,
          },
          edit: {
            type: 'dialog',
            title: 'Edit Article',
            metaOverrideSetName: 'CuratedContentArticleEditOverride',
            layout: CuratedContentArticleLayout,
            refetchResource: true,
          },
          delete: {
            type: 'dialog',
          },
        }
      }
    />
  );
}

CuratedContentArticleTable.defaultProps = {
  className: '',
};

CuratedContentArticleTable.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(CuratedContentArticleTable);
